<template>
  <el-dropdown trigger="click" @command="handleActions">
    <el-button
      type="primary"
      icon="el-icon-setting"
      data-qa="segment-settings-dropdown"
    >
      {{ $t('Audiences_Segment_Dropdown_Settings') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        command="editSegment"
        icon="el-icon-edit-outline"
        data-qa="edit-option"
      >
        {{ $t('Audiences_Segment_Action_Edit') }}
      </el-dropdown-item>
      <el-dropdown-item
        command="copySegment"
        icon="el-icon-document-copy"
        data-qa="copy-option"
      >
        {{ $t('Audiences_Segment_Action_Copy') }}
      </el-dropdown-item>
      <el-dropdown-item
        command="deleteSegmentConfirm"
        icon="el-icon-delete"
        data-qa="delete-option"
      >
        {{ $t('Audiences_Segment_Action_Delete') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
export default {
  components: {},
  props: {
    segment: {
      required: true,
      type: Object
    }
  },
  computed: {
    rowDeleteEndpoint() {
      return projectEndpoint({
        method: 'delete',
        url: `segments/${this.segment.id}`
      })
    }
  },
  methods: {
    rowUpdateRoute() {
      return projectRoute({
        name: 'AudienceSegmentUpdate',
        query: { id: this.segment.id }
      })
    },

    rowCopyRoute() {
      return projectRoute({
        name: 'AudienceSegmentCopy',
        query: { id: this.segment.id }
      })
    },

    confirmDelete() {
      const confirmButtonHookClass = 'segment-delete-confirm-hook'
      const cancelButtonHookClass = 'segment-delete-cancel-hook'

      this.$msgbox({
        title: this.$t('Audiences_Segment_DialogDelete_Title'),
        message: this.$t('Audiences_Segment_DialogDelete_Prompt'),
        showCancelButton: true,
        confirmButtonText: this.$t('Audiences_Segment_Button_Confirm'),
        cancelButtonText: this.$t('Audiences_Segment_Button_Cancel'),
        center: true,
        confirmButtonClass: confirmButtonHookClass,
        cancelButtonClass: cancelButtonHookClass
      }).then(() => {
        this.loading = true
        RestApi(this.rowDeleteEndpoint)
          .then(() => {
            this.$message({
              message: this.$t('Audiences_Segment_Message_DeleteSuccess'),
              type: 'success'
            })

            this.loading = false

            this.$router.push(
              projectRoute({
                name: 'AudienceSegmentList'
              })
            )
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
            this.loading = false
          })
      })
      this.$nextTick(() => {
        const msgBoxContainer = document.querySelector('.el-message-box')
        if (msgBoxContainer) {
          const confirmBtn = msgBoxContainer.querySelector(
            `.${confirmButtonHookClass}`
          )
          if (confirmBtn) {
            confirmBtn.setAttribute('data-qa', 'modal-delete-button')
          }
          const cancelBtn = msgBoxContainer.querySelector(
            `.${cancelButtonHookClass}`
          )
          if (cancelBtn) {
            cancelBtn.setAttribute('data-qa', 'modal-cancel-button')
          }
        }
      })
    },
    handleActions(action) {
      switch (action) {
        case 'deleteSegmentConfirm':
          this.confirmDelete()
          break
        case 'editSegment':
          this.$router.push(this.rowUpdateRoute())
          break
        case 'copySegment':
          this.$router.push(this.rowCopyRoute())
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/SegmentSettingsDropdown.vue